import "../scss/page.scss";

import "../scss/home.scss";

import "./scripts/slick/home.js";
import "./scripts/global/faq.js";